import React from 'react';
export const Design = () => (
  <svg width="201px" height="157px" viewBox="0 0 201 157" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-516.000000, -509.000000)">
        <g transform="translate(516.000000, 509.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M77.8667,152.3178 L43.9297,152.3178"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.9297,152.3178 L25.8937,152.3178"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M109.7447,42.6742 L109.7447,43.9892"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M109.7447,46.6215 L109.7447,47.9365"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M112.376,45.3051 L111.06,45.3051"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M108.4287,45.3051 L107.1137,45.3051"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M160.6177,74.2953 C160.6177,74.7783 160.2267,75.1693 159.7437,75.1693 C159.2617,75.1693 158.8697,74.7783 158.8697,74.2953 C158.8697,73.8133 159.2617,73.4213 159.7437,73.4213 C160.2267,73.4213 160.6177,73.8133 160.6177,74.2953"
            fill="#D62793"
          />
          <path
            d="M120.3423,52.0629 C120.3423,52.5449 119.9513,52.9369 119.4683,52.9369 C118.9863,52.9369 118.5943,52.5449 118.5943,52.0629 C118.5943,51.5809 118.9863,51.1889 119.4683,51.1889 C119.9513,51.1889 120.3423,51.5809 120.3423,52.0629"
            fill="#0B9CE5"
          />
          <path
            d="M50.5347,100.6254 L50.5347,102.3754"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M50.5347,105.8754 L50.5347,107.6254"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M54.0347,104.1254 L52.2847,104.1254"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M48.7847,104.1254 L47.0347,104.1254"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M128.8228,152.5004 C128.8228,154.8104 119.5168,156.6824 108.0358,156.6824 C96.5558,156.6824 87.2498,154.8104 87.2498,152.5004 C87.2498,150.1904 96.5558,148.3174 108.0358,148.3174 C119.5168,148.3174 128.8228,150.1904 128.8228,152.5004"
            fill="#D0D7DA"
          />
          <g transform="translate(69.000000, 70.710000)">
            <path
              d="M75.7437,41.3148 L76.6987,53.0308 L9.1697,58.5328 C9.1697,58.5328 4.6787,59.6558 4.2917,54.9168 C3.9057,50.1778 0.3647,6.7108 0.3647,6.7108 L72.4457,0.8368 L74.3807,24.5908"
              fill="#FFFFFF"
            />
            <path
              d="M75.7437,41.3148 L76.6987,53.0308 L9.1697,58.5328 C9.1697,58.5328 4.6787,59.6558 4.2917,54.9168 C3.9057,50.1778 0.3647,6.7108 0.3647,6.7108 L72.4457,0.8368 L74.3807,24.5908"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polygon
            fill="#FFFFFF"
            points="118.898 117.1401 84.65 119.9311 81.859 85.6831 116.107 82.8921"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="118.7759 115.6449 118.8979 117.1399 117.4019 117.2619"
          />
          <path
            d="M111.7193,117.725 L88.9863,119.578"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.851,5.702"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="86.1446 119.809 84.6496 119.931 84.5276 118.436"
          />
          <path
            d="M84.065,112.7524 L82.212,90.0204"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.851,5.702"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="81.981 87.1781 81.859 85.6831 83.354 85.5611"
          />
          <path
            d="M89.0376,85.0981 L111.7706,83.2451"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.851,5.702"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="114.6118 83.0141 116.1068 82.8921 116.2288 84.3871"
          />
          <path
            d="M116.6919,90.0707 L118.5449,112.8027"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.851,5.702"
          />
          <path
            d="M59.771,88.5336 L58.29,88.2976"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="54.3487 87.6703 52.8677 87.4343 53.1037 85.9523"
          />
          <path
            d="M54,80.3217 L57.588,57.7977"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.851,5.702"
          />
          <polyline
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="58.0362 54.9819 58.2722 53.5009 59.7532 53.7369"
          />
          <path
            d="M65.3848,54.6332 L87.9088,58.2212"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2.851,5.702"
          />
          <polyline
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="90.7246 58.6694 92.2056 58.9044 91.9696 60.3864"
          />
          <path
            d="M90.8208,67.6 L90.5848,69.081"
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M136.4785,103.7465 L125.0245,104.6795 C124.4245,104.7275 123.8925,104.2765 123.8435,103.6765 C123.7945,103.0755 124.2465,102.5445 124.8475,102.4955 L136.3005,101.5615 C136.9015,101.5135 137.4325,101.9645 137.4815,102.5645 C137.5305,103.1655 137.0795,103.6975 136.4785,103.7465"
            fill="#DDE5E8"
          />
          <path
            d="M136.166,99.9076 L124.712,100.8416 C124.111,100.8896 123.58,100.4376 123.531,99.8376 C123.482,99.2366 123.934,98.7056 124.534,98.6566 L135.988,97.7226 C136.588,97.6746 137.12,98.1256 137.169,98.7256 C137.218,99.3276 136.767,99.8586 136.166,99.9076"
            fill="#DDE5E8"
          />
          <path
            d="M132.0533,108.4985 L125.3803,109.0425 C124.7803,109.0915 124.2483,108.6405 124.1993,108.0395 C124.1503,107.4385 124.6013,106.9075 125.2023,106.8575 L131.8753,106.3145 C132.4753,106.2665 133.0073,106.7175 133.0563,107.3175 C133.1053,107.9185 132.6543,108.4495 132.0533,108.4985"
            fill="#DDE5E8"
          />
          <polygon
            fill="#FFFFFF"
            points="134.792 81.3695 122.546 82.3675 123.544 94.6135 135.79 93.6155"
          />
          <polygon
            stroke="#DDE5E8"
            points="134.792 81.3695 122.546 82.3675 123.544 94.6135 135.79 93.6155"
          />
          <path
            d="M106.4888,94.3285 L111.3628,97.0795"
            stroke="#0B9CE5"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M97.5171,110.2133 L100.7021,105.7163"
            stroke="#D62793"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M93.6221,97.9115 L91.9781,93.1295"
            stroke="#575700"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <g transform="translate(68.000000, 66.710000)">
            <path
              d="M3.0757,34.433 L0.7417,5.782 C0.7417,5.782 3.8037,0.515 7.1017,0.246 L11.4327,53.4 C6.6597,53.788 5.0727,58.935 5.0727,58.935 L3.0757,34.433"
              fill="#FFFFFF"
            />
            <path
              d="M3.0757,34.433 L0.7417,5.782 C0.7417,5.782 3.8037,0.515 7.1017,0.246 L11.4327,53.4 C6.6597,53.788 5.0727,58.935 5.0727,58.935 L3.0757,34.433"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M158.3033,90.3344 C159.0953,89.5704 159.7433,89.8474 159.7433,90.9464 L159.7433,112.3424 C159.7433,113.4414 158.8443,114.3424 157.7433,114.3424 L135.3783,114.3424 C134.2783,114.3424 134.0263,113.7174 134.8183,112.9544 L158.3033,90.3344 Z"
            fill="#F5C400"
          />
          <path
            d="M158.3033,90.3344 C159.0953,89.5704 159.7433,89.8474 159.7433,90.9464 L159.7433,112.3424 C159.7433,113.4414 158.8443,114.3424 157.7433,114.3424 L135.3783,114.3424 C134.2783,114.3424 134.0263,113.7174 134.8183,112.9544 L158.3033,90.3344 Z"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M152.438,108.7572 C153.538,108.7572 154.438,107.8572 154.438,106.7572 L154.438,103.1252 C154.438,102.0252 153.765,101.7222 152.942,102.4522 L147.331,107.4302 C146.508,108.1592 146.735,108.7572 147.835,108.7572 L152.438,108.7572 Z"
            fill="#F3F4F6"
          />
          <path
            d="M152.438,108.7572 C153.538,108.7572 154.438,107.8572 154.438,106.7572 L154.438,103.1252 C154.438,102.0252 153.765,101.7222 152.942,102.4522 L147.331,107.4302 C146.508,108.1592 146.735,108.7572 147.835,108.7572 L152.438,108.7572 Z"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M155.6963,114.3422 L155.6963,111.9922"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M152.5191,114.3422 L152.5191,113.1672"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M149.0122,114.3422 L149.0122,111.9922"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M145.835,114.3422 L145.835,113.1672"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M143.0835,114.3422 L143.0835,111.9922"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M139.9068,114.3422 L139.9068,113.1672"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M138.1392,152.2074 L159.8852,152.2074"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
